exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.banner[data-v-0c288b59] {\n  min-width: 100%;\n  height: auto;\n}\n.btn.blue.outlined[data-v-0c288b59]:hover {\n  background: #00a9f0;\n  color: #fff;\n}\n.btn.action.outlined[data-v-0c288b59]:hover {\n  background: #f16c64;\n  color: #fff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-0c288b59","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/auth/Signup.vue
// module id = 2626
// module chunks = 0